const { createApp, ref } = Vue

const filters = document.querySelector('.cat-filters'),
    defaultFilters = filters.cloneNode('true');

const MobileFilters = {
    props: {
        
    },
    data() {
        return {
            filters: [],
            searchValue: ''
        }
    },
    mounted(){
        this.filters = this.$parent.getFilters();
    },
    computed: {
    },
    methods: {
        toggleFilter(fIndex, vIndex) {
            const filterVariant = this.filters[fIndex].variants[vIndex];
            filterVariant.checked = !filterVariant.checked;
        },
        showAllFilterVariants(index) {
            this.filters[index].active = true;
            this.$parent.blockFormScroll(true)
        },
        hideAllFilterVariants(index) {
            this.filters[index].active = false;
            this.$parent.blockFormScroll(false)
        },
        countSelected(index) {
            const picked = this.filters[index].variants.filter(v => v.checked)
            return picked.length;
        }
    },
    template: `
        <li class="cat-filters__line" v-for="(f, fIndex) in filters" :key="f.name">
            <div class="cat-filters__line-header-wrp">
                <p class="cat-filters__line-header">{{ f.name }}</p>
                <button class="cat-filters__all-state"
                    type="button"
                    @click="showAllFilterVariants(fIndex)"
                    v-if="f.type == 'checkbox'"
                >
                    <span>Все</span>
                    <svg>
                        <use xlink:href="/img/icons.24.svg#arrowRightLight2"></use>
                    </svg>
                </button>
            </div>
            <ul class="cat-filters__top-btns"
                v-if="f.type == 'checkbox'"
            >
                <li v-for="(v, vIndex) in f.variants.slice(0, 8)">
                    <button
                        type="button"
                        :class="
                            v.checked ? 'cat-filters__top-btn cat-filters__top-btn--active' : 'cat-filters__top-btn'
                        " 
                        :data-value="v.value"
                        @click="toggleFilter(fIndex, vIndex)"
                    >{{v.header}}</button>
                </li>
            </ul>
            <ul class="cat-filters__checks"
                v-if="f.type == 'radio'"
            >
                <li v-for="v in f.variants">
                    <label class="check check--radio">
                        <input class="check__input" type="radio" name="sale" :value="v.value" >
                        <span class="check__label">{{ v.header }}<span class="cat-filters__filter-count">{{ v.count }}</span></span>
                    </label>
                </li>
            </ul>
            <div v-if="f.active"
                class="cat-filters__active-filter"
            >
                <div class="cat-filters__line-header-wrp cat-filters__line-header-wrp--center">
                    <button class="cat-filters__backbtn"
                        type="button"
                        @click="hideAllFilterVariants(fIndex)"
                    >
                        <svg>
                        <use xlink:href="/img/icons.24.svg#arrowRightLight2"></use>
                        </svg>
                    </button>
                    <p class="cat-filters__line-header">{{f.name}}</p>
                </div>
                <div class="cat-filters__toolbar">
                    <p class="cat-filters__total">Выбрано {{countSelected(fIndex)}}</p>
                    <div class="cat-filters__search-wrp">
                        <input class="cat-filters__search-input" type="text" placeholder="Поиск"
                            v-model="searchValue"
                        >
                        <svg class="cat-filters__search-icon">
                            <use xlink:href="/img/icons.24.svg#search2"></use>
                        </svg>
                    </div>
                </div>
                <ul class="cat-filters__checks">
                    <template v-for="(v, vIndex) in f.variants">
                        <li v-if="v.header.toLowerCase().indexOf(this.searchValue) != -1">
                            <label class="check">
                                <input class="check__input" type="checkbox" 
                                    :name="v.name"
                                    :value="v.value"
                                    :data-url-item="f.urlDepends"
                                    :checked="v.checked"
                                    @change="toggleFilter(fIndex, vIndex)"
                                >
                                    <span class="check__label">{{v.header}}
                                        <span class="cat-filters__filter-count">{{v.count}}</span>
                                    </span>
                            </label>
                        </li>
                    </template>
                </ul>
                <div class="cat-filters__submit">
                    <button class="cat-filters__submit-btn btn btn--blue"
                        type="button"
                        @click="hideAllFilterVariants(fIndex)"
                    >Применить</button>
                </div>
            </div>
        </li>
        
    `
};


createApp({
    data() {
        return {
            filters: [],
            mobile: window.innerWidth < 768,
            mobileHtml: ''
        }
    },
    mounted() {
        this.initFilters();
    },
    beforeCreate(){

    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {

    },
    components: {
        'mobile-filters': MobileFilters
    },
    methods: {
        handleResize() {
            this.mobile = window.innerWidth < 768;
        },
        initFilters() {
            // parse html and save data to object
            const blocks = defaultFilters.querySelectorAll('.cat-filters__line');
            blocks.forEach(block => {

                const lines = block.querySelectorAll('.check'),
                      input = block.querySelector('.check__input'),
                      filter = {},
                      varinants = [];

                if (!input) {
                    // it's price_range
                    return;
                }

                filter.name = block.querySelector('.cat-filters__line-header').textContent;
                filter.urlDepends = input.hasAttribute('data-url-item');
                filter.type = input.type;
                filter.showAll = false;
                // for mobile
                filter.active = false;
                        
                lines.forEach(line => {
                    const currentInput = line.querySelector('.check__input');
                    varinants.push({
                        header: line.querySelector('.cat-filters__filter-name').textContent,
                        count: line.querySelector('.cat-filters__filter-count').textContent,
                        value: currentInput.value,
                        checked: filter.type == 'radio' ? currentInput.checked : currentInput.hasAttribute('checked')
                    })
                });
                
                filter.variants = varinants;
                this.filters.push(filter);
            })
        },
        formSubmit(e) {
            e.preventDefault();

            const query = new URLSearchParams(new FormData(this.$refs.filterForm)).toString();
            console.log(query)
        },
        getFilters() {
            return this.filters;
        },
        toggleHidden(target) {
            const index = this.filters.findIndex(f => f.name == target)
            if (index != -1) {
                this.filters[index].showAll = !this.filters[index].showAll;
            }
        },
        isShown(target) {
            const index = this.filters.findIndex(f => f.name == target)
            if (index != -1) {
                return this.filters[index].showAll;
            } else {
                return false;
            }
        },
        blockFormScroll(block) {
            if (block) {
                this.$refs.filterForm.classList.add('cat-filters__form--blocked');
            } else {
                this.$refs.filterForm.classList.remove('cat-filters__form--blocked');
            }
        }
    }
}).mount(filters)